import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "v-center text-right pr-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        class: "appbar",
        density: _ctx.$vuetify.display.smAndDown ? 'compact' : 'prominent',
        color: "background"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.authed && _ctx.$vuetify.display.mdAndUp)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/sign-in"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("Sign in")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["density"]),
      (!_ctx.authed && _ctx.$vuetify.display.smAndDown)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/sign-in",
            class: "mobile-signin"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Sign in")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}